import { BlockGenAlgorithm } from '../game/defs/map';
import { InsideLevelRubberbandingOptions } from '../match2.util';

/**
 * Blockgen rubberbanding V2
 * @param step rubberbanding step
 * @param insideLevelOpts inside level options
 * @returns blockgen type
 */
export function rubberbandingV2(
  step: number,
  insideLevelOpts?: InsideLevelRubberbandingOptions,
): BlockGenAlgorithm {
  let difficulty = 0;

  // Calculate starting blockgen difficulty based on the rubberbanding ladder step.
  if (step >= 5) difficulty = 4;
  else if (step >= 2) difficulty = 3;
  else if (step >= -2) difficulty = 2;
  else if (step >= -5) difficulty = 1;

  if (insideLevelOpts) {
    const { obstacleCompletion, moveCompletion, continues } = insideLevelOpts;

    // Special Case: 2+ continues.
    if (continues > 1) return 'easy-v2-powerups';
    // Special Case: 1 continue.
    else if (continues > 0) return 'hard-v7-small-chains';
    // Inside adjustment activates when over 30% of moves are used.
    else if (moveCompletion > 30) {
      if (obstacleCompletion < moveCompletion) difficulty--;
      else if (obstacleCompletion > (2 / 3) * moveCompletion) difficulty++;
    }
  }

  if (difficulty >= 4) return 'hard-v7-small-chains';
  else if (difficulty === 3) return 'medium-small-chains';
  else if (difficulty === 2) return 'random';
  else if (difficulty === 1) return 'easy-v5-large-chains-2';

  return 'easy'; // difficulty <= 0
}
